import { Component, inject, input, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';

@Component({
  selector: 'auctions-items-search-bar',
  imports: [
    ButtonModule,
    FontAwesomeModule,
    FormsModule,
    InputGroupModule,
  ],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss'
})
export class SearchBarComponent implements OnInit {
  private router = inject(Router);

  public auctionId = input(0);
  public originalQuery = input('');
  public shouldGoToSearch = input(false);
  protected searchRequested = output<string>();

  protected searchQuery = '';
  protected icons = { faSearch: faSearch }

  ngOnInit() {
    this.searchQuery = this.originalQuery();
  }

  protected doSearch() {
    if (this.shouldGoToSearch()) {
      if (this.searchQuery != '') {
        this.router.navigate(['item-list/' + this.auctionId(), { query: this.searchQuery }]);
      }
    } else {
      this.searchRequested.emit(this.searchQuery);
    }
  }
}
